module.exports = __webpack_public_path__ + "static/media/share-icon.af5e36a7.svg";